import { render, staticRenderFns } from "./ProductInfoPage.vue?vue&type=template&id=f7c4efa4&scoped=true&"
import script from "./ProductInfoPage.vue?vue&type=script&lang=js&"
export * from "./ProductInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoPage.vue?vue&type=style&index=0&id=f7c4efa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c4efa4",
  null
  
)

export default component.exports